import { useState } from 'react'

import { Box, CardInfo, Icon, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import AddFundsModal from 'modules/banking/components/AddFundsModal'
import { accountNumberExtraFieldLabel } from 'modules/banking/lib/bankAccountNumbersHelpers'
import { useApplicationsContext } from 'modules/software_management/pages/ApplicationsPage'

const LowFundsNotification = () => {
  const { bankAccount } = useApplicationsContext()
  const [isModalOpen, setModalOpen] = useState(false)

  return (
    <>
      <Box width="full" cursor="pointer" onClick={() => setModalOpen(true)}>
        <CardInfo>
          <Box justifyContent="spaceBetween" flexDirection="row" alignItems="center">
            <Text.Normal weight="medium" color="grey1000">
              {i18n.t('software_management.software_setups.dashboard.header.low_funds')}
            </Text.Normal>
            <Icon.Medium icon="arrow-right" color="grey800" />
          </Box>
        </CardInfo>
      </Box>
      {isModalOpen && bankAccount && (
        <AddFundsModal
          bic={bankAccount.bic ?? bankAccount.sortCode ?? '-'}
          extraFieldLabel={accountNumberExtraFieldLabel(bankAccount.accountNumberType) || ''}
          accountNumber={bankAccount.accountNumber!}
          beneficiaryName={bankAccount.beneficiaryName!}
          onClose={() => setModalOpen(false)}
          mode="addFunds"
        />
      )}
    </>
  )
}

export default LowFundsNotification
